import DuckEntity from 'ducks/DuckEntity';
import DuckEntityForm from './DuckEntityForm';

const contactInstallmentSchedules = new DuckEntity('contactInstallmentSchedules');
const contactInstallmentSchedulesForm = new DuckEntityForm(
  'contactInstallmentSchedulesForm',
  contactInstallmentSchedules
);

export { contactInstallmentSchedules, contactInstallmentSchedulesForm };
